import { TwoFAVerification as TwoFAVerificationComponent } from "../components/verification/TwoFAVerification";

const TwoFAVerification = () => {
  return <TwoFAVerificationComponent />;
};

export default TwoFAVerification;
